import React, { useMemo } from 'react'
import { cMerge } from '@/shared/utils'

type RowProps = {
  children: React.ReactNode
} & React.ComponentPropsWithoutRef<'div'>

// type breakPointType = 'xs' | 'lg' | 'md' | 'sm' | 'xl' | 'xxl'
type ColProps = {
  children?: React.ReactNode
  className?: string
  xs?: number
  lg?: number
  md?: number
  sm?: number
  xxl?: number
  xl?: number
} & React.ComponentPropsWithoutRef<'div'>

export function Row({ children, className, ...props }: RowProps) {
  return (
    <div className={`grid grid-cols-12 gap-2 ${className}`} {...props}>
      {children}
    </div>
  )
}

export function Col({ children, className = '', ...props }: ColProps) {
  const defaultBreak = 3
  const ColClassName = useMemo(
    () =>
      cMerge([
        props?.xs && `col-span-${props?.xs || defaultBreak}`,
        props?.sm && `sm:col-span-${props?.sm}`,
        props?.md && `md:col-span-${props?.md}`,
        props?.lg && `lg:col-span-${props?.lg}`,
        props?.xl && `xl:col-span-${props?.xl}`,
        props?.xxl && `xxl:col-span-${props?.xxl}`
      ]),
    []
  )
  return (
    <div className={`${ColClassName} ${className}`} {...props}>
      {children}
    </div>
  )
}
